import React, {useState} from "react"
import { Button, IconButton} from '@material-ui/core';
import {DefaultComponentCreator, BaseRowActionButtonCreator} from "../../TableMapperCreator"
import BPMDialog from "../Dialogs/BPMDialog";

function PopUpComponent(props) {
    const [open, setOpen] = useState(false) 
    const [disabled, setDisabled] = useState(false)
    const handleClick = (e) => {
        e.stopPropagation();
        setOpen(true)
    }
    const handleClose = (e) =>{
        e.stopPropagation();
        setOpen(false)
    }

    const handleDisable = () => {
        setDisabled(true)
    }

    return(
        <div style={{ display: 'inline-flex', alignItems: 'center' }}>
            <span>
                {props.buttonType === "iconButton" ? 
                <IconButton disabled={disabled} size="medium" onClick={e => handleClick(e)} >{React.createElement(props.labelComponent, {rowData:props.rowData, data: props.data, disable: handleDisable})}</IconButton>
                    :
                <Button style={{fontSize:12}} onClick={e => handleClick(e)} >{React.createElement(props.labelComponent, {rowData:props.rowData, data:props.data,disable:handleDisable})}</Button>
                 }
            </span>
            <BPMDialog
                open={open}
                maxWidth='lg' 
                onClose={handleClose}
            >
                <div
                    style={{ height: '70vh', margin: 'auto' }}
                    onClick={(event) => event.stopPropagation()}
                >
                    {props.children(handleClose)}
                </div>
            </BPMDialog>
        </div>
    )
}


// Cell component creator version (strict signature: createWith(data, rowData, fieldAlign))
class PopUpCellComponentCreator extends DefaultComponentCreator{
    constructor(labelComponent, childrenComponent, popUpProps, type){
        super()
        this.labelComponent = labelComponent
        this.children = childrenComponent
        this.popUpProps = popUpProps
        this.type = type || null
    }

    createWith(data, rowData){
        let showData = true
        if(this.popUpProps && this.popUpProps.showData){
            showData = this.popUpProps.showData(data)
        }
        if(showData){
            return(
                <PopUpComponent buttonType={this.type} labelComponent={this.labelComponent} data={data.value} rowData={rowData}>
                    {(handleClose)=> React.createElement(this.children, { rowData:rowData, popupData: data.popupData, handleClose: handleClose, ...this.popUpProps })}
                </PopUpComponent>
            )
        }
        return null
    }
}

// Row action button creator version (strict signature: createWith(rowData, ctx))
class PopUpRowActionButtonCreator extends BaseRowActionButtonCreator{
    constructor(labelComponent, childrenComponent, popUpProps, type, actionId){
        super()
        this.labelComponent = labelComponent
        this.children = childrenComponent
        this.popUpProps = popUpProps
        this.type = type || 'iconButton'
        this.actionId = actionId || 'popup'
    }

    createWith(rowData, ctx){
        // Optional visibility guard similar to cell creator's showData
        if (this.popUpProps && typeof this.popUpProps.showData === 'function'){
            try {
                const shouldShow = this.popUpProps.showData(rowData)
                if (!shouldShow) return null
            } catch(_e) { /* ignore guard errors and show by default */ }
        }
        return (
            <PopUpComponent buttonType={this.type} labelComponent={this.labelComponent} data={rowData} rowData={rowData}>
                {(handleClose)=> React.createElement(this.children, { rowData, popupData: null, handleClose, ...this.popUpProps })}
            </PopUpComponent>
        )
    }
}

export { PopUpCellComponentCreator, PopUpRowActionButtonCreator }
export default PopUpCellComponentCreator
